import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/illustrations/vpn/multi-device-protection.svg")